import { CustomMaterialModule } from './../core/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ComponentsModule } from './components';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared-module/shared.module';
import { ModalService } from '../lib/services/modal.service';
import { QuestionsEffects } from './effects/questions.effects';
import { QuestionsViewComponent } from './containers/questions-view.component';
import { SingleQuestionComponent } from './components/single-question/single-question.component';
import { AddQuestionComponent } from './components/add-question.component';
import { TranslateModule } from '@ngx-translate/core';
import { LimitPreviewDirective } from './components/single-question/limit-preview.directive';
import { FormsModule } from '@angular/forms';
import { questionsReducer } from './reducers/questions.reducers';

@NgModule({
  declarations: [
    QuestionsViewComponent,
    SingleQuestionComponent,
    AddQuestionComponent,
    LimitPreviewDirective,
  ],
  providers: [ModalService],
  exports: [
    SingleQuestionComponent,
    AddQuestionComponent,
    LimitPreviewDirective,
  ],
  entryComponents: [AddQuestionComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: QuestionsViewComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'questions',
          },
        ],
      },
    ]),
    CommonModule,
    StoreModule.forFeature('questions', questionsReducer),
    EffectsModule.forFeature([QuestionsEffects]),
    FlexLayoutModule,
    TranslateModule,
    FormsModule,
    CustomMaterialModule,
  ],
})
export class QuestionsModule {}
